﻿class simplecriticallistdialog extends Tango.Component {
	widgetDidMount() {
		var _this = this;
		document.querySelectorAll("a[data-openDialogEventTypes]").forEach(function (a) {
			a.addEventListener("click", function () {
				_this.openDialog();
			});
		});
		
	}
	openDialog() {
		const sd = document.getElementById(this.props.selectDialogID);
		sd.style.width = 800 + 'px';
		sd.style.height = 550 + 'px';
		dialog.open(sd);
		return false;
	}

	onResult(state) {
		if (state == 0) {
			const sd = document.getElementById(this.props.selectDialogID);
			dialog.close(sd);
			return false;
		}
	}
};

Tango.registerComponent(simplecriticallistdialog, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));